import { cn } from '@core/utils';

interface PriceInfoProps {
  amount: number;
}

export const PriceInfo = ({ amount }: PriceInfoProps) => {
  return (
    <div>
      <div
        className={cn(
          'flex items-center gap-8 font-700 typo-body1',
          'tablet:typo-body2',
          'mobile:typo-body2',
        )}
      >
        <p>
          <span className="text-Gray-550 line-through">
            {amount.toLocaleString()}
          </span>
          <span className="font-600 text-Gray-550 line-through">원 </span>
        </p>
        {amount === 100000 ? (
          <span className="rounded-pill bg-B-25 px-12 py-4 font-700 text-B-500 typo-caption1">
            10만원 기부 → 모두 세액공제!
          </span>
        ) : null}
      </div>
      <div className="flex items-center gap-8 text-R-500">
        <span
          className={cn(
            'flex items-center gap-2 font-700 typo-h3',
            'tablet:typo-h5',
            'mobile:typo-h5',
          )}
        >
          0원
        </span>
        <span
          className={cn(
            'font-400 typo-body3',
            'tablet:typo-body4',
            'mobile:typo-body4',
          )}
        >
          기부세액 공제 시
        </span>
      </div>
    </div>
  );
};
